import { Reveal } from "./shared";

const WORDS = ["Nettoyer.", "Entretenir.", "Réparer.", "Améliorer."];

export const Manifesto = () => (
  <section className="bg-nuit py-24 lg:py-36" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-lagoon">Bien plus qu'un service de nettoyage</p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
        <div>
          {WORDS.map((w, i) => (
            <div key={w} className="overflow-hidden">
              <Reveal delay={i * 0.1} y={60}>
                <span className="font-display block text-5xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl">
                  {w}
                </span>
              </Reveal>
            </div>
          ))}
        </div>
        <div className="flex flex-col justify-end">
          <Reveal delay={0.2}>
            <p className="text-base leading-relaxed text-white/70 sm:text-lg">
              Chez Rosset Conciergerie &amp; Services, l'entretien d'un bien ne s'arrête pas au nettoyage.
              Une poignée se desserre, un mur doit être rafraîchi, une zone extérieure doit être remise
              en état ? L'objectif est d'apporter une solution concrète, sans devoir systématiquement
              faire intervenir plusieurs entreprises.
            </p>
            <p className="font-display mt-8 border-l-2 border-lagoon pl-6 text-lg font-medium leading-snug text-white sm:text-xl">
              Un seul interlocuteur pour de nombreux besoins du quotidien.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
